module.exports = __webpack_public_path__ + "assets/img/icon2.08fcb696.png";